<script setup>
const props = defineProps({
  locale: {
    type: String,
    default: "fa",
  },
});

const config = useRuntimeConfig();
const { data, error, status, pending } = await useLazyFetch(
  `/api/posts?locale=${props.locale}&category=news`
);

const posts = computed(() => {
  return data.value.body;
});

const blog = `/${props.locale}/news`;
</script>

<template>
  <div class="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
    <!-- Title -->
    <div class="max-w-2xl text-center mx-auto mb-10 lg:mb-14">
      <h2
        class="text-2xl font-bold md:text-4xl md:leading-tight dark:text-white"
      >
        {{ $t("readOurLatestNews") }}
      </h2>
    </div>
    <!-- End Title -->

    <!-- Grid -->

    <FetchWrapper :pending :error>
      <div
        v-if="!pending"
        class="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10 lg:mb-14"
      >
        <PostCard v-for="post in posts.slice(0, 4)" :data="post" />
      </div>
    </FetchWrapper>

    <!-- End Grid -->

    <!-- Card -->
    <div class="text-center">
      <div
        class="inline-block bg-white border shadow-sm rounded-full dark:bg-slate-900 dark:border-gray-800"
      >
        <div class="py-3 px-4 flex items-center gap-x-2">
          <p class="text-gray-600 dark:text-gray-400">
            {{ $t("wantToReadMore") }}
          </p>

          <NuxtLink
            :to="blog"
            class="inline-flex items-center gap-x-1.5 text-blue-600 decoration-2 hover:underline font-medium"
          >
            {{ $t("goHere") }}
            <svg
              class="flex-shrink-0 size-4 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m9 18 6-6-6-6" />
            </svg>
          </NuxtLink>
        </div>
      </div>
    </div>
    <!-- End Card -->
  </div>
</template>
